export default "__VITE_ASSET__2f59lpyf__"